module.exports = __webpack_public_path__ + "img/c4fe0d7.svg";